import { ReactNode } from 'react';
import { useMediaQuery } from '@providers/MediaQueryProvider';

import { BoardThemes, ChessBoard } from '@exports/ChessBoard';
import { ScoresheetSkeleton } from '@exports/Scoresheet';
import { cx } from '@libs/classnames';
import { ARRAY_EMPTY } from '@libs/constants';

import { GameButtonsSkeleton } from '@features/game/ui/GameButtonsSkeleton/GameButtonsSkeleton';
import { GameInfo } from '@features/game/ui/GameInfo/GameInfo';
import { GameLayout } from '@features/game/ui/GameLayout/GameLayout';
import { PlayerPanelSkeleton } from '@features/game/ui/PlayerPanelSkeleton';
import { IValidRoute } from '@features/shared/utils/router';

import styles from './FriendLobbyPage.module.css';

type Props = {
  avatar?: ReactNode;
  modal?: (className?: string) => ReactNode;
  boardTheme?: BoardThemes;
};

const BACK_LINK: IValidRoute = '/';

export function FriendLobbyPage({ avatar, modal, boardTheme }: Props) {
  const mediaQuery = useMediaQuery();
  const isDesktop = mediaQuery === 'desktop';
  const isMobile = mediaQuery === 'mobile' || mediaQuery === 'tablet';

  return (
    <>
      <GameLayout
        backLink={BACK_LINK}
        backLinkIsLogo
        header={
          <GameInfo
            title="Игра с другом"
            specs={ARRAY_EMPTY}
            mobileBackLink={BACK_LINK}
            mobileBacklinkIsLogo
            twoAvatars
          />
        }
        board={
          <ChessBoard
            theme={boardTheme}
            orientation="white"
            notation={isDesktop ? undefined : 'inside'}
          />
        }
        player1={<PlayerPanelSkeleton orientation="top" />}
        player2={<PlayerPanelSkeleton orientation="bottom" />}
        scoresheet={isDesktop ? <ScoresheetSkeleton /> : undefined}
        avatar={avatar}
        actions={<GameButtonsSkeleton />}
      />
      {modal?.(
        cx(styles.settings, {
          [styles.is_mobile]: isMobile,
        }),
      )}
    </>
  );
}
